import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { ICartLineInput, IShopifyCart, IShopifyProduct } from '@app/_shared/_models';
import { CartService } from '../../_services/cart.service';
import { GoogleAnalyticsService } from '../../_services/google-analytics.service';
import { RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink]
})
export class ProductCardComponent implements OnInit {
  private readonly cartService = inject(CartService);
  private readonly googleAnalyticsService = inject(GoogleAnalyticsService);

  public readonly isNew = input(false);
  public readonly product = input.required<IShopifyProduct>();
  public variantIndex = 0;

  ngOnInit(): void {
    const product = this.product();
    if (product) {
      for (let i = 0; i < product.variants.length; i += 1) {
        if (product.variants[i].inventory > 0) {
          this.selectVariant(i);
          break;
        }
      }
    }
  }

  public selectVariant(index: number): void {
    this.variantIndex = index;
  }

  public addProductToCart(): void {
    const product = this.product();
    this.cartService.insertCartItem(product.variants[this.variantIndex], 1, '');
    this.cartService.openDialog();
    this.googleAnalyticsService.itemAddedToCartConversion(product.variants[this.variantIndex]?.price);
    this.googleAnalyticsService.eventEmitter('Added Product to Cart', 'Shopping Cart', 'Added Product to Cart', 'Shopping Cart', 1);
  }
}
